import gql from "graphql-tag";

export const subscribeToConversations = gql`
    subscription {
        subscribeToConversations {
            ... on ConversationCategoryChangedEvent {
                id
                category
                nextCategories
                __typename
            }
            ... on ConversationOptOutChangedEvent {
                id
                optOutChannels
                __typename
            }
            ... on ParticipantRemovedFromConversationEvent {
                conversationId
                fromHydrationEvent
                __typename
            }
            ... on ParticipantAddedToConversationEvent {
                conversation {
                    id
                    category
                    nextCategories
                    contact {
                        id
                        firstName
                        lastName
                        businessName
                        address {
                            streetNumber
                            streetName
                            city
                            province
                            country
                            postalCode
                        }
                        externalId
                        locale
                        phoneNumber {
                            number
                            extension
                        }
                        capabilities
                        external {
                            externalId
                            metadata
                        }
                    }
                    hydration
                    topic {
                        id
                        name
                    }
                    topicIds
                    externalId
                    optOutChannels
                    participationMonths
                    isInbound
                }
                highlight
                fromHydrationEvent
                __typename
            }
            ... on ConversationContactChangedEvent {
                id
                firstName
                lastName
                businessName
                locale
            }
            ... on RepresentativeIncomingAvailableChangedEvent {
                incomingEnabled
            }
        }
    }
`;

// export const GetTeamConversationSubscription = gql`
//     subscription  {
//         conversations: api_ui_aggregated_conversation  {
//             channel
//             id: conversation_id
//             category {
//                 name:category
//             }
//             contactId: contact_id
//             firstName: contact_first_name
//             lastName: contact_last_name
//             phoneNumber: inbound_address
//             businessName: contact_business_name
//             externalId: contact_external_id
//             locale: contact_locale
//             outboundAddress: outbound_address
//             representativeId: representative_id
//             representativeUserId: representative_user_id
//             isInbound: is_inbound
//             optOut: opt_out
//             topics
//             hydration
//             messages(limit: 1, order_by: {sent_at: desc}) {
//                 body
//                 timestamp: sent_at
//             }
//         }
//     }
// `

export const GetTeamConversationSubscription = gql`
    subscription getConversations {
        all: touchless_account {
            services: conversation_services {
                conversations(where: {state: {_neq: ARCHIVED}}) {
                    id: uuid
                    primaryRepresentativeId: actor_uuid
                    category: state
                    hydration
                    metadata: context_json
                    createdAt: created_at
                    messages {
                        id: uuid
                        created_at
                        body: secret_value
                        media: context_text
                    }
                    topics {
                        id: parent_uuid
                        speaker_id: actor_uuid
                    }
                    representatives: participants(where: {channel: {_is_null: true}}) {
                        id: actor_uuid
                        contact {
                            lastName: family_name
                            firstName: given_name
                        }
                    }
                    contacts: participants(where: {channel: {_is_null: false}}) {
                        id: uuid
                        contactId: linked_uuid
                        externalId: external_id
                        representative_id: actor_uuid
                        inboundAddress: inbound_address
                        outboundAddress: outbound_address
                        metadata: context_json
                        locale
                        channel
                        opt_out {
                            added_at
                            channel_type
                            source
                        }
                        topics {
                            id: parent_uuid
                        }
                        contact {
                            lastName: family_name
                            firstName: given_name
                            locator
                            middleName: middle_name
                            parent_account_uuid
                            parent_config_id
                            parent_service_uuid
                            po_box
                            preferred_name
                            rural_route
                            street_direction
                            street_name
                            street_num
                            street_suffix
                            unit_num
                            unit_type
                        }
                    }
                }
            }
        }
    }
`

export const getTopicsSubscription = gql`
    subscription topics {
        topics: touchless_topic {
            id: uuid
            name: context_text
            description: context_text
            messageTemplates: templates {
                id: label
                topicId: parent_uuid
                locale
                template: context_text
                placeholders : context_json
            }
            contactCount: context_int
        }
    }
`;